/** @file ikNormalize: a vector scaled to unit length (private stand-in for math M1 vec3Normalize). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `v / |v|`; the zero vector stays `[0, 0, 0]` (no NaN). */
export function ikNormalize(v: Vec3): Vec3 {
  const n = Math.hypot(v[0], v[1], v[2]);
  return n === 0 ? [0, 0, 0] : [v[0] / n, v[1] / n, v[2] / n];
}
